import React from 'react';

const DataSection = props => {
	return (
		<React.Fragment>
			<div className="mb-4">
        <h5>{props.title}</h5>
        <div className="form-row">
          {props.fields.map(field => {
						let classes = "col-12 pb-1"
						classes = classes + ` col-lg-${field.size}`
            return (
							<div key={field.id} className={classes}>
								<label htmlFor={field.id}>{field.text}</label>
								<input type="text" id={field.id} name={field.id} className="form-control" value={field.value} disabled />
							</div>
						);
					})}
        </div>
      </div>
		</React.Fragment>
	);
};

export default DataSection;